<template>
    <v-footer
      v-if="!isElectron"
      class="footer elevation-5"
      :height="footerHeight"
      :class="footerJustify"
    >
      <v-container>
      <v-row>
        <v-col cols="12" md="4" sm="6" align="center">
          <div class="footer-first-col" :class="$vuetify.breakpoint.xs ? 'pb-6 text-center mx-auto': 'text-left'">
            <v-img class="footer-logo mb-8" :class="$vuetify.breakpoint.xs ? 'mx-auto' : ''" width="110px" src="/logo_blanc.png"></v-img>
            <p>Nuestro software basado en <abbr title="Inteligencia Artificial">IA</abbr> automatiza la contabilización de facturas y la conciliación bancaria.</p>
            <div class="f-link"><v-icon>mdi-phone-settings-outline</v-icon> <a href="tel:+34 93 183 88 23">+34 93 183 88 23</a></div>
            <div class="f-link mb-6"><v-icon>mdi-email-arrow-right-outline</v-icon> <a href="mailto:hola@inmatic.ai">hola@inmatic.ai</a></div>
            <app-btn-style3 hrefLink="https://app.inmatic.ai/signup">Pruébalo Gratis</app-btn-style3>
          </div>
        </v-col>
        <v-col class="menu-links" cols="12" md="2" sm="6" align="center">
          <div class="text-left menu-links-box">
            <div class="menu-title">Inmatic</div>
            <ul>
              <li v-for="(item, index) in menu.inmatic" :key="index">              
                <a v-if="item.path || item.href" :href="item.path ? item.path : item.href" :target="item.target ? item.target : ''" :rel="item.rel">
                  {{ item.name }}
                </a>
                <a v-else @click.stop="eval(item.call_to_action)">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </v-col>
        <v-col class="menu-links" cols="12" md="2" sm="6" align="center">
          <div class="text-left menu-links-box">
            <div class="menu-title">Servicios</div>
            <ul>
              <li v-for="(item, index) in menu.servicios" :key="index">              
                <a v-if="item.path || item.href" :href="item.path ? item.path : item.href" :target="item.target ? item.target : ''" :rel="item.rel">
                  {{ item.name }}
                </a>
                <a v-else @click.stop="eval(item.call_to_action)">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </v-col>
        <v-col class="menu-links" cols="12" md="2" sm="6" align="center">
          <div class="text-left menu-links-box">
            <div class="menu-title">Ayuda</div>
            <ul>
              <li v-for="(item, index) in menu.ayuda" :key="index">              
                <a v-if="item.path || item.href" :href="item.path ? item.path : item.href" :target="item.target ? item.target : ''" :rel="item.rel">
                  {{ item.name }}
                </a>
                <a v-else @click="openChat">{{ item.name }}</a>
              </li>
            </ul>
            <div class="menu-title mt-10">Area de Cliente</div>
            <ul>
              <li v-for="(item, index) in menu.area_cliente" :key="index">              
                <a v-if="item.path || item.href" :href="item.path ? item.path : item.href" :target="item.target ? item.target : ''" :rel="item.rel">
                  {{ item.name }}
                </a>
                <a v-else @click.stop="eval(item.call_to_action)">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </v-col>
        <v-col class="menu-links" cols="12" md="2" sm="6" align="center">
          <div class="text-left menu-links-box">
            <div class="menu-title">Legal</div>
            <ul>
              <li v-for="(item, index) in menu.legal" :key="index">              
                <a v-if="item.path || item.href" :href="item.path ? item.path : item.href" :target="item.target ? item.target : ''" :rel="item.rel">
                  {{ item.name }}
                </a>
                <a v-else @click.stop="eval(item.call_to_action)">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>
  
      <v-row class="footer-copyright">
        <v-col cols="12" offset-md="8" md="2" :align="$vuetify.breakpoint.smAndDown ? 'center' : ''">
          <div class="white--text pr-2">&copy; {{ (new Date()).getFullYear() }} - CONEPTUM S.L.</div>
        </v-col>
        <v-col cols="12" md="2" :order="$vuetify.breakpoint.smAndDown ? 'first' : 'last'">
          <div class="footer__socialmedia d-flex" :class="$vuetify.breakpoint.smAndDown ? 'justify-center' : ''">
            <a title="Facebook" class="social-link-icon" target="_blank" href="https://www.facebook.com/profile.php?id=100093515275305" rel="nofollow noopener">
              <v-avatar size="20px">
                <AppIcon src="/social_facebook.svg" :size="29" />
              </v-avatar>
            </a>
            <a title="Twitter" class="social-link-icon" target="_blank" href="https://twitter.com/turobotcontable" rel="nofollow noopener">
              <v-avatar size="20px">
                <AppIcon src="/social_twitter.svg" :size="29" />
              </v-avatar>
            </a>
            <a title="Linkedin" class="social-link-icon" target="_blank" href="https://www.linkedin.com/company/inmaticbcn/" rel="nofollow noopener">
              <v-avatar size="20px">
                <AppIcon src="/social_linkedin.svg" :size="29" />
              </v-avatar>
            </a>
            <a title="Instagram" class="social-link-icon" target="_blank" href="https://www.instagram.com/inmatic.ai/" rel="nofollow noopener">
              <v-avatar size="20px">
                <AppIcon src="/social_instagram.svg" :size="29" /></v-img>
              </v-avatar>
            </a>
          </div>
        </v-col>
      </v-row>
    </v-container>    
    </v-footer>
  </template>
  <script>
  import AppBtnStyle3 from '@/components/layout/AppBtnStyle3.vue'  
  
  export default {
  name: 'AppFooterPublic',
  components: {
    AppBtnStyle3
    },
  methods:{
  },
  data(){
    return {
      isElectron: false,      
      menu: {
        inmatic: [
          { name: 'Tarifas', path: 'https://inmatic.ai/tarifas/' },
          { name: 'Prueba gratis', href: 'https://app.inmatic.ai/signup' },
          { name: 'Blog', path: 'https://inmatic.ai/blog/'},
          { name: 'Casos de éxito', path: 'https://inmatic.ai/casos-de-exito/'},
          { name: 'Inteligencia artificial en la contabilidad', path: 'https://inmatic.ai/blog/inteligencia-artificial-contabilidad/' },        
        ],
        servicios: [
          { name: 'Contabilización automática de facturas', path: 'https://inmatic.ai', hash:"#hero" },
          { name: 'Conciliación bancaria',  path: 'https://inmatic.ai/bancos/'},
          { name: 'Programa Kit Digital', path: 'https://inmatic.ai/kit-digital/'},
          { name: 'Compatibilidad', path: 'https://inmatic.ai/compatibilidad/'},
          { name: 'Programa de Partner', path: 'https://inmatic.ai/partners/'},
          { name: 'Perfil de producto', path: 'https://inmatic.ai/como-funciona/'},
        ],
        ayuda: [
          { name: 'Centro de ayuda', href: 'https://ayuda.inmatic.ai/es/', target: '_blank', rel: 'nofollow noopener' },
          { name: 'Habla con un experto', call_to_action: "openChat" },        
        ] ,
        area_cliente: [
          { name: 'Iniciar sesión', href: 'https://app.inmatic.ai/login' },
          { name: 'Crear cuenta', href: 'https://app.inmatic.ai/signup' },      
        ],
        legal: [
          { name: 'Aviso Legal', path: 'https://inmatic.ai/legal/aviso-legal/', rel: 'nofollow' },
          { name: 'Condiciones de venta', path: 'https://inmatic.ai/legal/condiciones-de-venta/', rel: 'nofollow' },
          { name: 'Política de Privacidad', path: 'https://inmatic.ai/legal/politica-de-privacidad/', rel: 'nofollow' },
          { name: 'Política de Cookies', path: 'https://inmatic.ai/legal/politica-de-cookies/', rel: 'nofollow' },        
        ]      
      }
    }
  },
  methods: {
    openChat() {
      try {        
        window.$crisp.push(["do", "chat:open"]);         
      }
      catch {}
    }
  },
  mounted(){      
      this.isElectron = navigator.userAgent == 'InmaticApp';
  },
  computed:{       
    footerHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': 
          return '1750'
        case 'sm':
          return '1100'
        case 'md':
          return '620'        
        case 'lg':      
        case 'xl':
        default:
          return '520'
      }
    },
  
    footerJustify() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md':
          return 'justify-space-around'
        case 'lg':
        case 'xl':
        default:
          return 'justify-center'
      }
    },
    
  }
  }
  </script>
  
  <style>
  
  .footer {
    padding-top:84px;
    padding-bottom: 62px;
    background-color: #181818 !important;  
    font-family: "Roboto", sans-serif;
  }
  .footer .footer-first-col { 
    font-size: 14px;
    max-width: 240px;
  }
  .footer .footer-first-col p {
    margin-bottom: 50px;
    color: rgba(236, 236, 236, 1);
    font-size:12px;
  }
  .footer .footer-first-col .f-link {
    margin-bottom: 10px;
  }
  .footer .footer-first-col .f-link a { 
    color: rgba(236, 236, 236, 1);
    text-decoration: none;  
    font-size:14px;
  }
  .footer .footer-first-col .f-link .v-icon {
    color:rgba(51, 204, 255, 1);
    margin-right: 14px;
  }
  .footer .footer-first-col .f-link .v-icon__svg {
    height: 20px;
    width: 20px;
  }
  .footer .menu-links-box {
    max-width: 240px;
  }
  .footer .menu-links a {
    text-decoration: none;     
    color: #ECECEC;
    font-size: 14px;
  }
  .footer .menu-links .menu-title {
    font-size: 18px;
    color: #545454;
    font-weight: 600;
    margin-bottom: 30px;
  }
  .footer .menu-links ul {
    list-style: none;
    padding-left: 0px;
  }
  .footer .menu-links ul li {
    margin-bottom: 15px;
  }
  .footer .menu-links ul li a:hover {
    text-decoration: underline;
  }
  .footer .footer-copyright {
    font-size: 14px;
  }
  
  .footer .social-link-icon {
      text-decoration:none;
      margin-right: 13px;    
    }
  
  @media (min-width: 960px){
    .footer .container {
      max-width: 95%;
    }
  }
  
  @media (max-width: 600px) {
    .footer .menu-links-box {
      max-width: 155px;
    }
  }
  
  </style>